import React, { useState } from 'react'
import { KTSVG } from '../../../../helpers'
import { tabs } from '../../../../../app/pages/supportCenter/Support'
import ModalCreateTicket from '../modal/ModalCreateTicket'
import Swal from 'sweetalert2'

const EngageWidgetSupport = ({ tab, setTab }) => {
  // Hidden temporarily — const [show, setShow] = useState(false)

  const handleCreateTicket = () => {
    Swal.fire({
      title: 'Coming Soon',
      text: 'This feature is under development. Please check back later.',
      icon: 'info',
      confirmButtonText: 'OK',
    })
  }

  return (
    <div className='card mb-12'>
      <div className='card-body flex-column p-5'>
        <div className='card-rounded bg-light d-flex flex-stack flex-wrap p-5'>
          <ul className='nav flex-wrap border-transparent fw-bold'>
            {/* Tab order: FAQ's, Contact Us, Overview, Tickets */}
            <li className='nav-item my-1'>
              <a
                className={`btn btn-color-gray-600 btn-active-secondary btn-active-color-primary fw-bolder fs-8 fs-lg-base nav-link px-3 px-lg-8 mx-1 text-uppercase ${tab == tabs.faq && 'active'
                  }`}
                href='javascript:void(0)'
                onClick={() => setTab(tabs.faq)}
              >
                FAQ's
              </a>
            </li>
            <li className='nav-item my-1'>
              <a
                className={`btn btn-color-gray-600 btn-active-secondary btn-active-color-primary fw-bolder fs-8 fs-lg-base nav-link px-3 px-lg-8 mx-1 text-uppercase ${tab == tabs.contactUs && 'active'
                  }`}
                href='javascript:void(0)'
                onClick={() => setTab(tabs.contactUs)}
              >
                Contact Us
              </a>
            </li>
            <li className='nav-item my-1'>
              <a
                className={`btn btn-color-gray-600 btn-active-secondary btn-active-color-primary fw-bolder fs-8 fs-lg-base nav-link px-3 px-lg-8 mx-1 text-uppercase ${tab == tabs.overview && 'active'
                  }`}
                href='javascript:void(0)'
                onClick={() => setTab(tabs.overview)}
              >
                Overview
              </a>
            </li>
            <li className='nav-item my-1'>
              <a
                className={`btn btn-color-gray-600 btn-active-secondary btn-active-color-primary fw-bolder fs-8 fs-lg-base nav-link px-3 px-lg-8 mx-1 text-uppercase ${tab == tabs.tickets && 'active'
                  }`}
                href='javascript:void(0)'
                onClick={() => setTab(tabs.tickets)}
              >
                Tickets
              </a>
            </li>
          </ul>
          {/* Create Ticket shows Coming Soon — hidden: onClick={() => setShow(true)} */}
          <a
            href='javascript:void(0)'
            className='btn btn-primary fw-bold fs-8 fs-lg-base'
            onClick={handleCreateTicket}
          >
            Create Ticket
          </a>
        </div>
      </div>
      {/* Hidden temporarily: <ModalCreateTicket show={show} setShow={setShow} /> */}
    </div>
  )
}

export default EngageWidgetSupport
